// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"363f9a20","456":"7c2572e7","624":"9332c510","636":"9f0dd2a3"}[chunkId] + ".chunk.js";
};